// extracted by mini-css-extract-plugin
export default {"note":"LandContingencyNote_note__RbnVx"};